import isEmpty from './isEmpty'
import getAdjReason from './getAdjReason'
//---------------------------
// get skill opt adj reasons
//---------------------------
export default function getSkillOptAdjReasons({ adjs, type }) {
  console.log('--------------------------')
  console.log('IN getSkillOptAdjReasons')
  console.log('ADJS PASSED IN = ', window.$deepCopy(adjs))
  console.log('TYPE PASSED IN = ' + type)
  // build reasons as a single string; when no reasons are found, return
  // an empty string so grids/cells render blank instead of "[]"
  let reasons = ''
  //---------------------------------------------
  // only consider adjs that belong to this type
  // (e.g. Athletics should not see Disorder Rune)
  //---------------------------------------------
  const relevantAdjs = adjs.filter((a) => a.name === type)
  console.log('FILTERED RELEVANT ADJS = ', window.$deepCopy(relevantAdjs))
  //-----------
  // loop adjs
  //-----------
  relevantAdjs.forEach((a) => {
    console.log('-----------------------------------------')
    console.log('2. Processing adj = ', window.$deepCopy(a))
    //-------------------
    // build adj reasons
    //-------------------
    if (!isEmpty(a.adj_reason)) {
      let reason = getAdjReason(a.adj_reason, a.adj_value)
      console.log('3. Built reason = ', reason)
      //-------------------
      // append to reasons
      //-------------------
      // first adj pass
      if (isEmpty(reasons)) {
        reasons = reason
        console.log(`4. Set initial reason = `, reasons)
      } else {
        // subsequent adj passes
        reasons += '. ' + reason
        console.log(`5. Appending reason = `, reasons)
      }
    }
  })
  return reasons
}
